module.exports = __webpack_public_path__ + "img/duoliyun_kefu.eb803c14.jpg";